import $ from 'jquery';

function loadPageInBackGround(url, e, dept){
    if($('.js-page-content').length > 0) {
        e.preventDefault();
        var data = $.param({
            richNavAjax : true
        });
        $.get(url, data, function (data) {
            var content = $(data);
            var $pageContent = content.find('.js-page-content');
            if($pageContent.length === 0) return;
            $('.js-page-content').html($pageContent);
            
            if (dept === 'F' && typeof window.insertWomenCarousalMarkupsByAjax == 'function') {
                window.insertWomenCarousalMarkupsByAjax();
            } else if (dept === 'M' && typeof window.insertMenCarousalMarkupsByAjax == 'function') {
                window.insertMenCarousalMarkupsByAjax();
            }

            // We need to manually reload the top banner carousel when the page is partially reloaded
            // after click on left nav department link.
            // top banner reload issue workaround - start
            $('.js-top-banner-department-reload').html(content.find('.js-top-banner-department-reload').html());
            var banerSlideshow = $('.js-slideshow');
            if (banerSlideshow.children('.banner--slider-list__item').length > 1) {
                banerSlideshow.slick({
                    autoplay: true,
                    autoplaySpeed: 6000,
                    prevArrow: '.banner__slick-prev',
                    nextArrow: '.banner__slick-next',
                    touchThreshold: 20,
                });
                $('.banner__slick-next, .banner__slick-prev').on('click', function() {
                    banerSlideshow.slick('slickPause');
                });
            } else {
                $('.banner__slick-next, .banner__slick-prev').hide();
                $('.banner--slider-list').show();
            }
            // top banner reload issue workaround - end

            $('#rev-logo').html(content.find('#rev-logo').html());
            $('#rev-logo').attr('href', content.find('#rev-logo').attr('href'));
            $('#global-nav-div').html(content.find('#global-nav-div').html());
            $(window).off('scroll.lazyloadimage');
            initMobileHp();
            content.find('#js-footer-container').find("script").each(function() {
                eval($(this).text());
            });

            history.pushState("", document.title, url);
        })
    }
}

function richNavHpClickHandler(e) {

    if(!$(this).hasClass('js-active')) return;

    if($(this).hasClass('js-rich-nav-womens')){
        loadPageInBackGround("/r/mobile/index_women.jsp?main_hm", e, 'F');
    }

    if($(this).hasClass('js-rich-nav-mens')){
        loadPageInBackGround("/r/mobile/index_men.jsp?main_hm", e, 'M');
    }

    if($(this).hasClass('js-rich-nav-beauty')){
        loadPageInBackGround("/content/lp/beauty/mobile/?main_hm", e);
    }
    if($(this).hasClass('js-rich-nav-collections')){
        loadPageInBackGround("/content/lp/collections-shop/mobile/?main_hm", e);
    }
}
$(document).ready(function(){
    $('.js-global__account, .menu__my-settings, .js-global__customercare, .js-global__info').find('.nav-side__link').each(function(){
        var href = $(this).attr('href');
        if(href && window.location.pathname !== '/r/mobile/' && href.indexOf(window.location.pathname) !== -1){
            $(this).addClass("u-underline");
        }
    });
    $('.js-rich-nav-hp').click(richNavHpClickHandler);
});



// WEBPACK FOOTER //
// ./src/scripts/modules/sidebar.js